import { useState } from 'react';

function ProjectCard({ project, onClick }) {
  const [imgError, setImgError] = useState(false);
  const showImage = project.previewImage && !imgError;

  return (
    <div className="project-card" onClick={() => onClick(project)}>
      {project.liveUrl && <span className="project-card-live-badge">LIVE</span>}
      <h3 className="project-card-name">{project.name}</h3>
      <p className="project-card-tagline">{project.tagline}</p>
      {showImage ? (
        <img
          src={project.previewImage}
          alt={`${project.name} preview`}
          className="project-card-preview"
          onError={() => setImgError(true)}
        />
      ) : (
        <div className="project-card-preview project-card-preview-fallback">
          <span>{project.name}</span>
        </div>
      )}
      <p className="project-card-cta">Click to learn more</p>
    </div>
  );
}

export default ProjectCard;
